import { render, staticRenderFns } from "./NewShopNoOA.vue?vue&type=template&id=bb038062&"
import script from "./NewShopNoOA.vue?vue&type=script&lang=js&"
export * from "./NewShopNoOA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports